import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'source']

  static values = {
    successContent: {
      default: 'Copied!',
      type: String,
    },
    successDuration: {
      default: 2000,
      type: Number,
    },
  }

  connect() {
    if (!this.hasButtonTarget) return

    this.originalContent = this.buttonTarget.innerHTML
  }

  copied() {
    if (!this.hasButtonTarget) return

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.buttonTarget.innerHTML = this.successContentValue

    this.timeout = setTimeout(() => {
      this.buttonTarget.innerHTML = this.originalContent
    }, this.successDurationValue)
  }

  copy(event) {
    event.preventDefault()

    const text = this.sourceTarget.innerHTML || this.sourceTarget.value

    navigator.clipboard.
      writeText(text).
      then(() => this.copied())
  }
}
